import React from 'react';

const HotelCustomerInvoice = () => {
  return (
    <div>
      <h1>HotelCustomerInvoice</h1>
    </div>
  );
};

export default HotelCustomerInvoice;
